module.exports = __webpack_public_path__ + "img/Property 1=icon007.efba1e81.svg";